module.exports = __webpack_public_path__ + "d6b5b664755ae293fefaab4511db8b9b.svg";